<template lang="html">
    <div class="page" id="groups">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/messages.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>Groups</h2>
                <ul class="links">
                    <li style="transform: translateY(-2px)">
                        <button
                            class="openSettings"
                            @click.prevent="deleteOn = !deleteOn"
                            type="button"
                            name="button"
                        >
                            <img class="bin" v-if="!deleteOn" src="@/assets/bin.svg" /><img
                                v-else
                                class="bin"
                                src="@/assets/bin-red.svg"
                            />
                        </button>
                    </li>
                    <li>
                        <router-link class="cancel" :to="{ name: 'proMessages' }"
                            ><x-icon class="icon"
                        /></router-link>
                    </li>
                </ul>
            </header>

            <ul class="groupList" v-if="groups.length > 0">
                <li v-for="(group, index) in groups" :key="group.id">
                    <router-link
                        :to="{
                            name: 'proPlayerMessagesGroup',
                            params: { id: group.id },
                            query: { group: group.name },
                        }"
                    >
                        {{ group.name }}
                        <img class="icon" src="@/assets/arrow-right-white.svg" />
                    </router-link>
                    <button
                        v-if="deleteOn && group.name !== 'All Players'"
                        class="button red"
                        @click.prevent="removeGroup(index)"
                    >
                        <img class="minus" src="@/assets/minus.svg" />
                    </button>
                </li>
            </ul>

            <empty-placeholder v-else>
                TIP: Create message groups here and add the Players you would like to receive
                messages for that group. To get started tap the button below.
            </empty-placeholder>

            <form class="addGroup" v-if="formOpen" @submit.prevent="addGroup">
                <input
                    v-model="form.name"
                    maxlength="255"
                    type="text"
                    placeholder="Your group title here"
                />
                <has-error class="info error" :form="form" field="name"></has-error>
                <button :disabled="form.busy" class="button" type="submit" name="button">
                    {{ form.busy ? "Please wait..." : "Save" }}
                </button>
            </form>
            <button
                v-else
                @click.prevent="formOpen = true"
                class="button dark left"
                type="button"
                name="button"
            >
                Add a group
                <plus-icon class="icon" />
            </button>
        </div>
    </div>
</template>

<script>
import EmptyPlaceholder from "@/components/App/empty-placeholder";

import FadeImage from "@/components/App/fade-image";
import { Form, HasError } from "vform";
import { PlusIcon, XIcon } from "vue-feather-icons";
export default {
    name: "new-message",
    components: { EmptyPlaceholder, FadeImage, PlusIcon, HasError, XIcon },
    computed: {
        groups() {
            return this.$store.state.groups;
        },
    },
    created() {
        this.getGroups();
    },
    data() {
        return {
            deleteOn: false,
            formOpen: false,
            form: new Form({
                name: "",
            }),
        };
    },
    methods: {
        getGroups() {
            if (this.groups.length == 0) {
                this.form.get("/group").then((groups) => {
                    this.$store.dispatch("getGroups", groups.data);
                });
            }
        },
        addGroup() {
            this.form.post("/group").then((response) => {
                this.$store.dispatch("addGroup", response.data);
                this.form.name = "";
                this.formOpen = false;
            });
        },
        removeGroup(index) {
            this.$confirm("Are you sure you'd like to remove this group?", () => {
                this.$store.dispatch("removeGroup", this.groups[index]);
                this.$notify({
                    text: "Group removed",
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#groups {
    .addGroup {
        margin-bottom: 20px;
        input[type="text"] {
            background: white;
            padding: 20px;
            border-radius: $radius;
            width: 100%;
            max-width: 100%;
            border: 0px;
            font-size: 1rem;
            margin-bottom: 10px;
            color: $green_0;
            &:focus {
                outline: 0;
                box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.1);
            }
        }
    }
    .groupList {
        margin-bottom: 30px;
        li {
            margin-bottom: 10px;
            position: relative;
            a {
                background: white;
                border-radius: 12px;
                padding: 18px 20px;
                display: block;
                height: 52px;
                color: $green_0;
                text-decoration: none;
                position: relative;
                .icon {
                    position: absolute;
                    right: 20px;
                    top: 19px;
                }
            }
            button {
                position: absolute;
                right: 0px;
                top: 0px;
                width: 60px;
                height: 100%;
                border-radius: 0px;
                border-top-right-radius: $radius;
                border-bottom-right-radius: $radius;
                width: 64px;
                padding: 0px;
                .minus {
                    margin-left: 7px;
                }
                &:before {
                    content: "";
                    width: 12px;
                    background: blue;
                    height: 100%;
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    background: white;
                    border-top-right-radius: $radius;
                    border-bottom-right-radius: $radius;
                }
            }
        }
    }
}
</style>
